/* eslint-disable */
import React from "react";
import { useState } from "react";
import { Chart } from "react-google-charts";

import filter from "lodash/filter";

import HeSelect from "../../components/HeSelect";
import HeAppWrapper from "../../components/HeAppWrapper";
import "./App.scss";
import all_states from "./assets/states";
import fireData from "./assets/wildfire-threats.json";


let tableHeader = [
    { type: "string", label: "City or Town" },
    { type: "string", label: "State" },
    { type: "number", label: "Population" },
    { type: "number", label: "Num. of 100-1,000 ac. wildfires that occurred < 700 ft. from town" },
    { type: "number", label: "Num. of 1,000-5,000 ac. wildfires that occurred < 2 mi. from town" },
    { type: "number", label: "Num. of 5,000+ ac. wildfires that occurred < 10 mi. from town" }
];
let tableDataAll = [];
fireData.forEach(row => {
    tableDataAll.push([row.city, row.state, row.population, row.num_fires_1, row.num_fires_2, row.num_fires_3]);
});


function App() {
    const [state, setState] = useState({
        tableDataAll: tableDataAll,
        tableDataFiltered: tableDataAll
    });


    return (
        <HeAppWrapper className="app-comm-threatened-wildfire">
            <div style={{ width: 740, margin: "10px 0px" }}>
                <span style={{ textAlign: "center" }}>
                    <h3>
                        Explore which communities have been threatened
                        <br />
                        by 100+ acre wildfires, 2000-2017
                    </h3>
                </span>
                Click the column headers in the data table below to change the sort order.
                <br />
                Select a state to limit the list of counties:
                <div style={{ width: 200, paddingLeft: 20 }}>
                    <HeSelect
                        data={all_states.map(function(d) {
                            return { value: d.st_abbr, label: d.state_name };
                        })}
                        defaultStyle={false}
                        onChange={val => {
                            let filteredData = state.tableDataAll;
                            if (val[1] !== "US") {
                                filteredData = filter(state.tableDataAll, tableRow => {
                                    return tableRow[1] === val.value;
                                });
                            }
                            setState(prev => ({ ...prev, tableDataFiltered: filteredData }));
                        }}
                    />
                </div>
            </div>
            <div id="table">{renderTable()}</div>
        </HeAppWrapper>
    );
    function renderTable() {
        return (
            <Chart
                chartType="Table"
                loader={<div>Loading Table</div>}
                data={[tableHeader].concat(state.tableDataFiltered)}
                width={740}
                options={{
                    sortColumn: 2,
                    sortAscending: false,
                    showRowNumber: true,
                    cssClassNames: { headerCell: "he-google-sortable-table" }
                }}
            />
        );
    }
}

export default App;


